import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import { useBEM } from '../../../utils';
import { IconButton } from '../../IconButton';
import "./styles.css";
var _a = useBEM('lk-ui__tabs__scroller'), scrollerClassName = _a[0], _ = _a[1], scrollerElement = _a[2];
var _b = scrollerElement('content'), scrollerContentClassName = _b[0], scrollerContentModifier = _b[1];
var _c = useBEM('navButton'), navButton = _c[0], navButtonModifier = _c[1];
export var Scroller = function (_a) {
    var _b;
    var className = _a.className, children = _a.children;
    var containerRef = useRef(null);
    var contentRef = useRef(null);
    var _c = useState(false), scrollEnabled = _c[0], setScrolling = _c[1];
    var _d = useState(false), scrollLeftAllowed = _d[0], allowLeftScrolling = _d[1];
    var _e = useState(false), scrollRightAllowed = _e[0], allowRightScrolling = _e[1];
    useEffect(function () {
        var _a;
        var resizeHandler = function () {
            var containerElement = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
            var contentElement = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current;
            if (!containerElement || !contentElement)
                return;
            var containerWidth = containerElement.getBoundingClientRect().width;
            var contentWidth = contentElement.scrollWidth;
            var needScroll = contentWidth > containerWidth;
            if (needScroll && !scrollEnabled) {
                setScrolling(true);
            }
            else if (!needScroll && scrollEnabled) {
                setScrolling(false);
            }
        };
        var scrollHandler = function () {
            var containerElement = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
            var contentElement = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current;
            if (!containerElement || !contentElement)
                return;
            var containerWidth = containerElement.getBoundingClientRect().width;
            var contentWidth = contentElement.scrollWidth;
            var contentScrollLeft = contentElement.scrollLeft;
            var scrollOnStart = contentScrollLeft === 0;
            var scrollOnEnd = Math.round(contentScrollLeft + containerWidth) >= contentWidth;
            allowRightScrolling(!scrollOnEnd && scrollEnabled);
            allowLeftScrolling(!scrollOnStart && scrollEnabled);
        };
        resizeHandler();
        scrollHandler();
        window.addEventListener('resize', resizeHandler);
        (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', scrollHandler);
        return function () {
            var _a;
            window.removeEventListener('resize', resizeHandler);
            (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', scrollHandler);
        };
    }, [scrollEnabled, scrollLeftAllowed, scrollRightAllowed]);
    var scrollClassName = cn(scrollerContentClassName, (_b = {},
        _b[scrollerContentModifier('enable')] = scrollEnabled,
        _b));
    var onRightScrollClick = function () {
        var contentElement = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current;
        if (!contentElement)
            return;
        contentElement.scrollLeft = contentElement.scrollLeft + 100;
    };
    var onLeftScrollClick = function () {
        var contentElement = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current;
        if (!contentElement)
            return;
        contentElement.scrollLeft = contentElement.scrollLeft - 100;
    };
    return (React.createElement("div", { className: cn(scrollerClassName, className), ref: containerRef },
        React.createElement("div", { className: scrollClassName, ref: contentRef }, children),
        scrollEnabled && (React.createElement(React.Fragment, null,
            scrollLeftAllowed && (React.createElement(IconButton, { className: cn(navButton, navButtonModifier('leftArrow')), iconName: Icons.NavArrowLeft, onClick: onLeftScrollClick, size: 'large' })),
            scrollRightAllowed && (React.createElement(IconButton, { className: cn(navButton, navButtonModifier('rightArrow')), iconName: Icons.NavArrowRight, onClick: onRightScrollClick, size: 'large' }))))));
};
